import { computed } from "vue";
import { useStoreItem } from "../itemStore.store";
import { useSceneTree } from "../scene/sceneTree";
import { defaultIndexStructure, useIndexStore } from "./indices.store";
import { useSceneNodesStore } from "../scene/sceneNodes.store";
import type { SceneElementData } from "../sceneElement/SceneElementData";
import type { SceneNodeItem } from "../scene/SceneNodeItem";

export const useIndex = useStoreItem(defaultIndexStructure, useIndexStore, (indexRef, indexStore) => {
  const treeNode = computed(() => {
    if (!indexRef.value) return null;
    return useSceneTree().elementNodes.get(indexRef.value.uid) ?? null;
  });
  const sceneNode = computed(() => {
    if (!treeNode.value) return null;
    return treeNode.value.node;
  });

  function updateNodeDataKey<K extends keyof SceneElementData>(key: K, value: SceneElementData[K]) {
    if (!treeNode.value) return;
    return useSceneNodesStore().updateDataKey<"element">(treeNode.value.id, key, value);
  }

  function updateNodeKey<K extends keyof SceneNodeItem>(key: K, value: SceneNodeItem[K]) {
    if (!treeNode.value) return;
    return useSceneNodesStore().updateKey(treeNode.value.id, key, value);
  }

  return {
    treeNode,
    sceneNode,
    updateNodeKey,
    updateNodeDataKey
  };
});
